import { FeedbackRating } from '../../../hooks/useFeedbackReducer/constants';
import RatingsButton from './RatingsButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const orderedFeedbackItems = [FeedbackRating.UNHAPPY, FeedbackRating.NEUTRAL, FeedbackRating.HAPPY];
const FeedbackRatingsStep = ({
  setRating
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: orderedFeedbackItems.map(type => {
      return /*#__PURE__*/_jsx(RatingsButton, {
        onClick: () => setRating(type),
        type: type
      }, type);
    })
  });
};
export default FeedbackRatingsStep;